import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  // 接口请求成功事件
  {
    name: 'API_REQUEST_SUCCESS',
    value: 'api_request_success'
  },
  // 接口响应成功事件
  {
    name: 'API_RESPONSE_SUCCESS',
    value: 'api_response_success'
  },
  // 接口响应失败事件
  {
    name: 'API_RESPONSE_FAIL',
    value: 'api_response_fail'
  },
  // 接口报错事件
  {
    name: 'API_DATA_ERROR',
    value: 'api_data_error'
  },
  // 登陆过期事件
  {
    name: 'LOGIN_EXPIRED',
    value: 'login_expired'
  },
  // 控件启禁用事件
  {
    name: 'CONTROL_EDITABLE',
    value: 'control_editable'
  },
  // 控件显隐事件
  {
    name: 'CONTROL_VISIBLE',
    value: 'control_visible'
  },
  // 组合表单表单切换事件
  {
    name: 'COMBINATION_PAGE_TABCHANGE',
    value: 'combination_page_tabchange'
  },
  // 搜索事件
  {
    name: 'SEARCH',
    value: 'search'
  },
  // 消息事件
  {
    name: 'POST_MESSAGE',
    value: 'post_message'
  },
  // echarts 图表 legend 点击事件
  {
    name: 'ECHARTS_LEGEND_SELECTED',
    value: 'echarts_legend_selected'
  },
  // echarts 图表点击事件
  {
    name: 'ECHARTS_CLICK',
    value: 'echarts_click'
  },
]

export default consts